<div #longContent class="long-content" (scroll)="onScroll()">
  <div #contentContainer class="content-container">
    <ng-content></ng-content>
  </div>
</div>
<!-- <app-dots class="mt-2" [dots]="dots" (activeDotChange)="activeDotChange($event)" [(activeDot)]="activeDot"></app-dots> -->

<img *ngIf="dots > 1" src="assets/shop/slideshow-nav.png" class="nav-arrow nav-arrow-left" (click)="scroll('left')">
<img *ngIf="dots > 1" src="assets/shop/slideshow-nav.png" class="nav-arrow nav-arrow-right" (click)="scroll('right')">
